<template>
  <div class="cfg-eti">
    <!-- SETA O STATUS DE CARREGANDO DA PAGINA -->
    <RF-Status v-if="statusGeral !== ''" :cpntStatus='statusGeral' :cpntTamanho='5'></RF-Status>

    <!-- SETA OS DADOS DA TELA -->
    <div v-else>
      <table>
        <tr>
          <td class="modelo linha-1">
            <App-Select :data-time="time" class="cfg-eti--seletor"
            :cpntStatus='campos.seletor.status'
            :cpntId='campos.seletor.id'
            :cpntTabIndex='campos.seletor.tabIndex'
            :cpntNome='campos.seletor.nome'
            :cpntValue='campos.seletor.value'
            :cpntMensagem='campos.seletor.mensagem'
            :cpntMensagemTipo='campos.seletor.mensagemTipo'
            :cpntDisabled='campos.seletor.disabled'
            :cpntMostrar='campos.seletor.mostrar'
            :cpntExplica='campos.seletor.explica'
            :cpntPlaceholder='campos.seletor.placeholder'
            :cpntValueRef='campos.seletor.valueRef'
            :cpntRouter='campos.seletor.router'
            :cpntMethod='campos.seletor.method'
            :cpntField='campos.seletor.field'
            :cpntWhere='campos.seletor.where'
            :cpntAddButForm='campos.seletor.addButForm'
            :cpntKeyMostra='campos.seletor.keyMostra'
            :cpntTipoOrder='campos.seletor.tipoOrder'
            :cpntOrder='campos.seletor.order'
            :cpntOptions='campos.seletor.options'
            :cpntKeyValue='campos.seletor.keyValue'
            :cpntSearchMinimo='campos.seletor.searchMinimo'
            :cpntMask='campos.seletor.mask'
            :cpntOptionInicialNome='campos.seletor.optionInicialNome'
            :cpntOptionInicialValue='campos.seletor.optionInicialValue'
            :cpntOptionBold='campos.seletor.optionBold'
            
            :cpntOnBuscarOptions='campos.seletor.onBuscarOptions'
            :cpntOnChange='campos.seletor.onChange'
            :cpntOnBlur='campos.seletor.onBlur'
            :cpntOnRealizaBusca='campos.seletor.onRealizaBusca'
            :cpntOnKeyPressEnter='campos.seletor.onKeyPressEnter'
            ref="seletor"
            ></App-Select>

            <App-Input :data-time="time" class="cfg-eti--nome" :style="cpntComputedSeletor === '' ? 'visibility: hidden !important;' : ''"
            :cpntStatus='campos.nome.status'
            :cpntId='campos.nome.id'
            :cpntClassDivFnomeld='campos.nome.classDivFnomeld'
            :cpntNome='campos.nome.nome'
            :cpntValue='campos.nome.value'
            :cpntAutoComplete='campos.nome.autocomplete'
            :cpntMask='campos.nome.mask'
            :cpntOptionInicialNome='campos.nome.optionInicialNome'
            :cpntOptionInicialValue='campos.nome.optionInicialValue'
            :cpntDisabled='campos.nome.disabled'
            :cpntMostrar='campos.nome.mostrar'
            :cpntAutoFocus='campos.nome.autofocus'
            :cpntMensagem='campos.nome.mensagem'
            :cpntMensagemTipo='campos.nome.mensagemTipo'
            :cpntPlaceholder='campos.nome.placeholder'
            :cpntPosicionar='campos.nome.posicionar'
            :cpntOnChange='campos.nome.onChange'
            :cpntOnBlur='campos.nome.onBlur'
            :cpntExplica='campos.nome.explica'
            ref='nome'
            ></App-Input>

            <App-Select :data-time="time" class="cfg-eti--copiar" :style="cpntComputedSeletor === '' ? 'visibility: hidden !important;' : ''"
            :cpntStatus='campos.copiar.status'
            :cpntId='campos.copiar.id'
            :cpntTabIndex='campos.copiar.tabIndex'
            :cpntNome='campos.copiar.nome'
            :cpntValue='campos.copiar.value'
            :cpntMensagem='campos.copiar.mensagem'
            :cpntMensagemTipo='campos.copiar.mensagemTipo'
            :cpntDisabled='campos.copiar.disabled'
            :cpntMostrar='campos.copiar.mostrar'
            :cpntExplica='campos.copiar.explica'
            :cpntPlaceholder='campos.copiar.placeholder'
            :cpntValueRef='campos.copiar.valueRef'
            :cpntRouter='campos.copiar.router'
            :cpntMethod='campos.copiar.method'
            :cpntField='campos.copiar.field'
            :cpntWhere='campos.copiar.where'
            :cpntAddButForm='campos.copiar.addButForm'
            :cpntKeyMostra='campos.copiar.keyMostra'
            :cpntTipoOrder='campos.copiar.tipoOrder'
            :cpntOrder='campos.copiar.order'
            :cpntOptions='campos.copiar.options'
            :cpntKeyValue='campos.copiar.keyValue'
            :cpntSearchMinimo='campos.copiar.searchMinimo'
            :cpntMask='campos.copiar.mask'
            :cpntOptionInicialNome='campos.copiar.optionInicialNome'
            :cpntOptionInicialValue='campos.copiar.optionInicialValue'
            
            :cpntOnBuscarOptions='campos.copiar.onBuscarOptions'
            :cpntOnChange='campos.copiar.onChange'
            :cpntOnBlur='campos.copiar.onBlur'
            :cpntOnRealizaBusca='campos.copiar.onRealizaBusca'
            :cpntOnKeyPressEnter='campos.copiar.onKeyPressEnter'
            ref="copiar"
            ></App-Select>
          </td>

          <td rowspan="4" class="exemplo" :style="cpntComputedSeletor === '' || cpntComputedSeletor === '__NOVO__'  ? 'visibility: hidden !important;' : ''">
            <div class="etiqueta">
              <div class="titulo">
                <svg aria-hidden="true" class="fa fa-angle-double-right"></svg> Pré-visualização etiqueta <svg aria-hidden="true" class="fa fa-angle-double-left"></svg>
                
                <div>
                  <App-Input :data-time="time" class="cfg-eti--qtdeEx" style="width: 35px; vertical-align: 0px;"
                  :cpntStatus='campos.qtdeEx.status'
                  :cpntId='campos.qtdeEx.id'
                  :cpntClassDivFnomeld='campos.qtdeEx.classDivFnomeld'
                  :cpntNome='""'
                  :cpntValue='campos.qtdeEx.value'
                  :cpntAutoComplete='campos.qtdeEx.autocomplete'
                  :cpntMask='campos.qtdeEx.mask'
                  :cpntOptionInicialNome='campos.qtdeEx.optionInicialNome'
                  :cpntOptionInicialValue='campos.qtdeEx.optionInicialValue'
                  :cpntDisabled='campos.qtdeEx.disabled'
                  :cpntMostrar='campos.qtdeEx.mostrar'
                  :cpntAutoFocus='campos.qtdeEx.autofocus'
                  :cpntMensagem='campos.qtdeEx.mensagem'
                  :cpntMensagemTipo='campos.qtdeEx.mensagemTipo'
                  :cpntPlaceholder='campos.qtdeEx.placeholder'
                  :cpntPosicionar='campos.qtdeEx.posicionar'
                  :cpntOnChange='campos.qtdeEx.onChange'
                  :cpntOnBlur='campos.qtdeEx.onBlur'
                  :cpntExplica='campos.qtdeEx.explica'
                  ref='qtdeEx'
                  ></App-Input>
                  {{ campos.qtdeEx.nome }}
                </div>
              </div>
              
              <App-Etiqueta v-if="[ '', null, undefined, '__NOVO__' ].indexOf(etiquetas.modelo) === -1" :key="('upd-' + updateVis) + ('params-' + JSON.stringify(etiquetas))"
              :cpntModelo="etiquetas.modelo"
              :cpntEtiquetaExemplo="JSON.parse(JSON.stringify({ id: 'EXEMPLO', qtde: Number(etiquetas.qtde) }))"
              ></App-Etiqueta>
            </div>
          </td>
        </tr>
        
        <tr :style="cpntComputedSeletor === '' ? 'visibility: hidden !important;' : ''">
          <td class="modelo linha-margin">
            <App-Input :data-time="time" class="cfg-eti--margem_esquerda"
            :cpntStatus='campos.margem_esquerda.status'
            :cpntId='campos.margem_esquerda.id'
            :cpntClassDivFnomeld='campos.margem_esquerda.classDivFnomeld'
            :cpntNome='campos.margem_esquerda.nome'
            :cpntValue='campos.margem_esquerda.value'
            :cpntAutoComplete='campos.margem_esquerda.autocomplete'
            :cpntMask='campos.margem_esquerda.mask'
            :cpntOptionInicialNome='campos.margem_esquerda.optionInicialNome'
            :cpntOptionInicialValue='campos.margem_esquerda.optionInicialValue'
            :cpntDisabled='campos.margem_esquerda.disabled'
            :cpntMostrar='campos.margem_esquerda.mostrar'
            :cpntAutoFocus='campos.margem_esquerda.autofocus'
            :cpntMensagem='campos.margem_esquerda.mensagem'
            :cpntMensagemTipo='campos.margem_esquerda.mensagemTipo'
            :cpntPlaceholder='campos.margem_esquerda.placeholder'
            :cpntPosicionar='campos.margem_esquerda.posicionar'
            :cpntOnChange='campos.margem_esquerda.onChange'
            :cpntOnBlur='campos.margem_esquerda.onBlur'
            :cpntExplica='campos.margem_esquerda.explica'
            ref='margem_esquerda'
            ></App-Input>

            <App-Input :data-time="time" class="cfg-eti--margem_topo"
            :cpntStatus='campos.margem_topo.status'
            :cpntId='campos.margem_topo.id'
            :cpntClassDivFnomeld='campos.margem_topo.classDivFnomeld'
            :cpntNome='campos.margem_topo.nome'
            :cpntValue='campos.margem_topo.value'
            :cpntAutoComplete='campos.margem_topo.autocomplete'
            :cpntMask='campos.margem_topo.mask'
            :cpntOptionInicialNome='campos.margem_topo.optionInicialNome'
            :cpntOptionInicialValue='campos.margem_topo.optionInicialValue'
            :cpntDisabled='campos.margem_topo.disabled'
            :cpntMostrar='campos.margem_topo.mostrar'
            :cpntAutoFocus='campos.margem_topo.autofocus'
            :cpntMensagem='campos.margem_topo.mensagem'
            :cpntMensagemTipo='campos.margem_topo.mensagemTipo'
            :cpntPlaceholder='campos.margem_topo.placeholder'
            :cpntPosicionar='campos.margem_topo.posicionar'
            :cpntOnChange='campos.margem_topo.onChange'
            :cpntOnBlur='campos.margem_topo.onBlur'
            :cpntExplica='campos.margem_topo.explica'
            ref='margem_topo'
            ></App-Input>

            <App-Input :data-time="time" class="cfg-eti--margem_direita"
            :cpntStatus='campos.margem_direita.status'
            :cpntId='campos.margem_direita.id'
            :cpntClassDivFnomeld='campos.margem_direita.classDivFnomeld'
            :cpntNome='campos.margem_direita.nome'
            :cpntValue='campos.margem_direita.value'
            :cpntAutoComplete='campos.margem_direita.autocomplete'
            :cpntMask='campos.margem_direita.mask'
            :cpntOptionInicialNome='campos.margem_direita.optionInicialNome'
            :cpntOptionInicialValue='campos.margem_direita.optionInicialValue'
            :cpntDisabled='campos.margem_direita.disabled'
            :cpntMostrar='campos.margem_direita.mostrar'
            :cpntAutoFocus='campos.margem_direita.autofocus'
            :cpntMensagem='campos.margem_direita.mensagem'
            :cpntMensagemTipo='campos.margem_direita.mensagemTipo'
            :cpntPlaceholder='campos.margem_direita.placeholder'
            :cpntPosicionar='campos.margem_direita.posicionar'
            :cpntOnChange='campos.margem_direita.onChange'
            :cpntOnBlur='campos.margem_direita.onBlur'
            :cpntExplica='campos.margem_direita.explica'
            ref='margem_direita'
            ></App-Input>

            <App-Input :data-time="time" class="cfg-eti--margem_rodape"
            :cpntStatus='campos.margem_rodape.status'
            :cpntId='campos.margem_rodape.id'
            :cpntClassDivFnomeld='campos.margem_rodape.classDivFnomeld'
            :cpntNome='campos.margem_rodape.nome'
            :cpntValue='campos.margem_rodape.value'
            :cpntAutoComplete='campos.margem_rodape.autocomplete'
            :cpntMask='campos.margem_rodape.mask'
            :cpntOptionInicialNome='campos.margem_rodape.optionInicialNome'
            :cpntOptionInicialValue='campos.margem_rodape.optionInicialValue'
            :cpntDisabled='campos.margem_rodape.disabled'
            :cpntMostrar='campos.margem_rodape.mostrar'
            :cpntAutoFocus='campos.margem_rodape.autofocus'
            :cpntMensagem='campos.margem_rodape.mensagem'
            :cpntMensagemTipo='campos.margem_rodape.mensagemTipo'
            :cpntPlaceholder='campos.margem_rodape.placeholder'
            :cpntPosicionar='campos.margem_rodape.posicionar'
            :cpntOnChange='campos.margem_rodape.onChange'
            :cpntOnBlur='campos.margem_rodape.onBlur'
            :cpntExplica='campos.margem_rodape.explica'
            ref='margem_rodape'
            ></App-Input>
          </td>
        </tr>
        <tr :style="cpntComputedSeletor === '' ? 'visibility: hidden !important;' : ''">
          <td class="modelo linha-2">
            <App-Input :data-time="time" class="cfg-eti--celula_mm_largura"
            :cpntStatus='campos.celula_mm_largura.status'
            :cpntId='campos.celula_mm_largura.id'
            :cpntClassDivFnomeld='campos.celula_mm_largura.classDivFnomeld'
            :cpntNome='campos.celula_mm_largura.nome'
            :cpntValue='campos.celula_mm_largura.value'
            :cpntAutoComplete='campos.celula_mm_largura.autocomplete'
            :cpntMask='campos.celula_mm_largura.mask'
            :cpntOptionInicialNome='campos.celula_mm_largura.optionInicialNome'
            :cpntOptionInicialValue='campos.celula_mm_largura.optionInicialValue'
            :cpntDisabled='campos.celula_mm_largura.disabled'
            :cpntMostrar='campos.celula_mm_largura.mostrar'
            :cpntAutoFocus='campos.celula_mm_largura.autofocus'
            :cpntMensagem='campos.celula_mm_largura.mensagem'
            :cpntMensagemTipo='campos.celula_mm_largura.mensagemTipo'
            :cpntPlaceholder='campos.celula_mm_largura.placeholder'
            :cpntPosicionar='campos.celula_mm_largura.posicionar'
            :cpntOnChange='campos.celula_mm_largura.onChange'
            :cpntOnBlur='campos.celula_mm_largura.onBlur'
            :cpntExplica='campos.celula_mm_largura.explica'
            ref='celula_mm_largura'
            ></App-Input>

            <App-Input :data-time="time" class="cfg-eti--celula_mm_altura"
            :cpntStatus='campos.celula_mm_altura.status'
            :cpntId='campos.celula_mm_altura.id'
            :cpntClassDivFnomeld='campos.celula_mm_altura.classDivFnomeld'
            :cpntNome='campos.celula_mm_altura.nome'
            :cpntValue='campos.celula_mm_altura.value'
            :cpntAutoComplete='campos.celula_mm_altura.autocomplete'
            :cpntMask='campos.celula_mm_altura.mask'
            :cpntOptionInicialNome='campos.celula_mm_altura.optionInicialNome'
            :cpntOptionInicialValue='campos.celula_mm_altura.optionInicialValue'
            :cpntDisabled='campos.celula_mm_altura.disabled'
            :cpntMostrar='campos.celula_mm_altura.mostrar'
            :cpntAutoFocus='campos.celula_mm_altura.autofocus'
            :cpntMensagem='campos.celula_mm_altura.mensagem'
            :cpntMensagemTipo='campos.celula_mm_altura.mensagemTipo'
            :cpntPlaceholder='campos.celula_mm_altura.placeholder'
            :cpntPosicionar='campos.celula_mm_altura.posicionar'
            :cpntOnChange='campos.celula_mm_altura.onChange'
            :cpntOnBlur='campos.celula_mm_altura.onBlur'
            :cpntExplica='campos.celula_mm_altura.explica'
            ref='celula_mm_altura'
            ></App-Input>

            <App-Input :data-time="time" class="cfg-eti--celula_linha_qtde"
            :cpntStatus='campos.celula_linha_qtde.status'
            :cpntId='campos.celula_linha_qtde.id'
            :cpntClassDivFnomeld='campos.celula_linha_qtde.classDivFnomeld'
            :cpntNome='campos.celula_linha_qtde.nome'
            :cpntValue='campos.celula_linha_qtde.value'
            :cpntAutoComplete='campos.celula_linha_qtde.autocomplete'
            :cpntMask='campos.celula_linha_qtde.mask'
            :cpntOptionInicialNome='campos.celula_linha_qtde.optionInicialNome'
            :cpntOptionInicialValue='campos.celula_linha_qtde.optionInicialValue'
            :cpntDisabled='campos.celula_linha_qtde.disabled'
            :cpntMostrar='campos.celula_linha_qtde.mostrar'
            :cpntAutoFocus='campos.celula_linha_qtde.autofocus'
            :cpntMensagem='campos.celula_linha_qtde.mensagem'
            :cpntMensagemTipo='campos.celula_linha_qtde.mensagemTipo'
            :cpntPlaceholder='campos.celula_linha_qtde.placeholder'
            :cpntPosicionar='campos.celula_linha_qtde.posicionar'
            :cpntOnChange='campos.celula_linha_qtde.onChange'
            :cpntOnBlur='campos.celula_linha_qtde.onBlur'
            :cpntExplica='campos.celula_linha_qtde.explica'
            ref='celula_linha_qtde'
            ></App-Input>

            <App-Select :data-time="time" class="cfg-eti--pagina_linha_qtde"
            :cpntStatus='campos.pagina_linha_qtde.status'
            :cpntId='campos.pagina_linha_qtde.id'
            :cpntTabIndex='campos.pagina_linha_qtde.tabIndex'
            :cpntNome='campos.pagina_linha_qtde.nome'
            :cpntValue='campos.pagina_linha_qtde.value'
            :cpntMensagem='campos.pagina_linha_qtde.mensagem'
            :cpntMensagemTipo='campos.pagina_linha_qtde.mensagemTipo'
            :cpntDisabled='campos.pagina_linha_qtde.disabled'
            :cpntMostrar='campos.pagina_linha_qtde.mostrar'
            :cpntExplica='campos.pagina_linha_qtde.explica'
            :cpntPlaceholder='campos.pagina_linha_qtde.placeholder'
            :cpntValueRef='campos.pagina_linha_qtde.valueRef'
            :cpntRouter='campos.pagina_linha_qtde.router'
            :cpntMethod='campos.pagina_linha_qtde.method'
            :cpntField='campos.pagina_linha_qtde.field'
            :cpntWhere='campos.pagina_linha_qtde.where'
            :cpntAddButForm='campos.pagina_linha_qtde.addButForm'
            :cpntKeyMostra='campos.pagina_linha_qtde.keyMostra'
            :cpntTipoOrder='campos.pagina_linha_qtde.tipoOrder'
            :cpntOrder='campos.pagina_linha_qtde.order'
            :cpntOptions='campos.pagina_linha_qtde.options'
            :cpntKeyValue='campos.pagina_linha_qtde.keyValue'
            :cpntSearchMinimo='campos.pagina_linha_qtde.searchMinimo'
            :cpntMask='campos.pagina_linha_qtde.mask'
            :cpntOptionInicialNome='campos.pagina_linha_qtde.optionInicialNome'
            :cpntOptionInicialValue='campos.pagina_linha_qtde.optionInicialValue'
            :cpntOptionBold='campos.pagina_linha_qtde.optionBold'
            
            :cpntOnBuscarOptions='campos.pagina_linha_qtde.onBuscarOptions'
            :cpntOnChange='campos.pagina_linha_qtde.onChange'
            :cpntOnBlur='campos.pagina_linha_qtde.onBlur'
            :cpntOnRealizaBusca='campos.pagina_linha_qtde.onRealizaBusca'
            :cpntOnKeyPressEnter='campos.pagina_linha_qtde.onKeyPressEnter'
            ref="pagina_linha_qtde"
            ></App-Select>
          </td>
        </tr>
        <tr :style="cpntComputedSeletor === '' ? 'visibility: hidden !important;' : ''">
          <td class="modelo linha-3">
            <App-Ckeditor :data-time="time" class="cfg-eti--celula_conteudo"
            :cpntStatus='campos.celula_conteudo.status'
            :cpntId='campos.celula_conteudo.id'
            :cpntClassDivField='campos.celula_conteudo.classDivField'
            :cpntNome='campos.celula_conteudo.nome'
            :cpntValue='campos.celula_conteudo.value'
            :cpntAutoComplete='campos.celula_conteudo.autocomplete'
            :cpntDisabled='campos.celula_conteudo.disabled'
            :cpntMostrar='campos.celula_conteudo.mostrar'
            :cpntMensagem='campos.celula_conteudo.mensagem'
            :cpntMensagemTipo='campos.celula_conteudo.mensagemTipo'
            :cpntConfig='campos.celula_conteudo.config'
            :cpntExplica='campos.celula_conteudo.explica'
            :cpntTabIndex='campos.celula_conteudo.tabIndex'

            :cpntOnChange='campos.celula_conteudo.onChange'
            :cpntOnBlur='campos.celula_conteudo.onBlur'
            ref='celula_conteudo'
            ></App-Ckeditor>

            <App-Toggles :data-time="time" class="cfg-eti--padrao"
            :cpntStatus='campos.padrao.status'
            :cpntId='campos.padrao.id'
            :cpntClassDivField='campos.padrao.classDivField'
            :cpntNome='campos.padrao.nome'
            :cpntValue='campos.padrao.value'
            :cpntMostrar='campos.padrao.mostrar'
            :cpntMensagem='campos.padrao.mensagem'
            :cpntMensagemTipo='campos.padrao.mensagemTipo'
            :cpntOn='campos.padrao.on'
            :cpntOff='campos.padrao.off'
            :cpntExplica='campos.padrao.explica'
            :cpntWidth='campos.padrao.width'
            :cpntTabIndex='campos.padrao.tabIndex'
            :cpntDisabled='campos.padrao.disabled'
            :cpntOnChange='campos.padrao.onChange'
            :cpntOnBlur='campos.padrao.onBlur'
            ref='padrao'
            ></App-Toggles>

            <App-Toggles :data-time="time" class="cfg-eti--atualizarPDR" v-if="$store.state.token.usuario === 'SuporteRF'"
            :cpntStatus='campos.atualizarPDR.status'
            :cpntId='campos.atualizarPDR.id'
            :cpntClassDivField='campos.atualizarPDR.classDivField'
            :cpntNome='campos.atualizarPDR.nome'
            :cpntValue='campos.atualizarPDR.value'
            :cpntMostrar='campos.atualizarPDR.mostrar'
            :cpntMensagem='campos.atualizarPDR.mensagem'
            :cpntMensagemTipo='campos.atualizarPDR.mensagemTipo'
            :cpntOn='campos.atualizarPDR.on'
            :cpntOff='campos.atualizarPDR.off'
            :cpntExplica='campos.atualizarPDR.explica'
            :cpntWidth='campos.atualizarPDR.width'
            :cpntTabIndex='campos.atualizarPDR.tabIndex'
            :cpntDisabled='campos.atualizarPDR.disabled'
            :cpntOnChange='campos.atualizarPDR.onChange'
            :cpntOnBlur='campos.atualizarPDR.onBlur'
            ref='atualizarPDR'
            ></App-Toggles>
          </td>
        </tr>
        <tr :style="cpntComputedSeletor === '' ? 'visibility: hidden !important;' : ''">
          <td class="modelo linha-4">
            <App-Button :cpntStatus="statusButton" cpntClass="btn btn-primary" @onClick="cfgEtiquetaSalvar">Salvar</App-Button>
          </td>
        </tr>
      </table>

    </div>
  </div>
</template>

<style socped>
  .cfg-eti > div {
    text-align: center;
    width: 90%;
    margin: 0px auto;
    border: 1px solid #ccc;
    background: #e9e9e9;
    border-radius: 8px;
    padding: 30px 15px 10px 15px;
  }
    .cfg-eti > div > table {
      width: 100%;
    } 
      .cfg-eti > div > table > tr > td {
        vertical-align: top;
      }
      .cfg-eti > div > table > tr > td.modelo {
        width: 680px;
        max-width: 680px;
      }
      .cfg-eti > div > table > tr > td.exemplo {
        width: calc(100% - 420px);
        /* vertical-align: top; */
        padding-top: 0px !important;
        padding-left: 10px;
      }
        .cfg-eti > div > table > tr > td.exemplo > .etiqueta {
          margin-top: -20px;
        }
          .cfg-eti > div > table > tr > td.exemplo > .etiqueta > .titulo {
            font-weight: bold;
            font-size: calc(100% + 1px);
            /* padding-bottom: 5px; */
          }
      .cfg-eti > div > table > tr > td:not(.linha-1) {
        padding-top: 25px;
      }
        .cfg-eti > div > table > tr > td.linha-1 > .cfg-eti--copiar,
        .cfg-eti > div > table > tr > td.linha-1 > .cfg-eti--seletor {
          width: 165px;
        }
        .cfg-eti > div > table > tr > td.linha-1 > .cfg-eti--nome {
          margin-right: 10px;
          margin-left: 10px;
          width: calc(100% - 350px);
        }
        .cfg-eti > div > table > tr > td.linha-2 > div {
          width: calc((100% - 30px) / 4);
        }
        .cfg-eti > div > table > tr > td.linha-2 > div:not(:first-child) {
          margin-left: 10px;
        }
        .cfg-eti > div > table > tr > td.linha-3 > div {
          margin-bottom: 22px !important;
        }
        .cfg-eti > div > table > tr > td.linha-4 {
          padding-top: 10px !important;
        }
          .cfg-eti > div > table > tr > td.linha-margin > div {
            width: calc((100% - 30px) / 4);
          }
          .cfg-eti > div > table > tr > td.linha-margin > div:not(:first-child) {
            margin-left: 10px;
          }
          .cfg-eti > div > table > tr > td.linha-4 > button {
            width: 100px;
          }
        .cfg-eti > div > table > tr > td > .cfg-eti--padrao {
          width: 180px;
          float: left;
        }
        .cfg-eti > div > table > tr > td > .cfg-eti--atualizarPDR {
          width: 180px;
          float: right;
        }
</style>

<style>
  .cfg-eti > div > table > tr > td > div > label,
  .cfg-eti > div > table > tr > td > div > input {
    width: 100%;
    text-align: center;
  }

  .cfg-eti > div > table > tr > td.linha-3 > div > label {
    top: -18px;
    margin-bottom: 0px !important;
  }

  .cfg-eti > div > table > tr > td.exemplo > .etiqueta > div > div > embed {
    height: auto !important;
    min-height: 450px
  }
  
  .cfg-eti > div > table > tr > td.exemplo > .etiqueta > .titulo > div > div > input  {
    text-align: center;
  }

  .cfg-eti > div > table > tr > td > .cfg-eti--padrao > div,
  .cfg-eti > div > table > tr > td > .cfg-eti--atualizarPDR > div {
    width: 100% !important;
  }
  .cfg-eti > div > table > tr > td > .cfg-eti--padrao > label {
    text-align: left !important;
  }
  .cfg-eti > div > table > tr > td > .cfg-eti--atualizarPDR > label {
    text-align: right !important;
  }
</style>

<script>
  export default {
    props: {
      cpntTipo: {
        required: true
      }
    },
    components: {
      'App-Ckeditor': () => import('@/components/rf-geral/ckeditor/RF-Ckeditor.vue'),
      'App-Etiqueta': () => import('@/components/config/Etiqueta/Etiqueta.vue')
    },
    data: function () {
      return {
        time: '',
        statusGeral: 'carregando',
        statusButton: '',
        updateVis: '',
        etiquetas: { modelo: '', qtde: '12' },
        campos: {
          seletor: {
            id: 'cfg-eti--seletor',
            status: '',
            value: '',
            nome: 'Etiqueta:',
            keyValue: 'id',
            keyMostra: [ 'nome' ],
            options: [],
            optionInicialNome: 'Selecione',
            onBuscarOptions: this.cfgEtiquetaBuscarModelos,
            onChange: this.cfgEtiquetaOnChange
          },
          copiar: {
            id: 'cfg-eti--copiar',
            status: '',
            value: '',
            nome: 'Copiar de:',
            keyValue: 'id',
            keyMostra: [ 'nome' ],
            options: [],
            optionInicialNome: 'Selecione',
            onBuscarOptions: this.cfgEtiquetaBuscarModelos,
            onChange: this.cfgEtiquetaOnChange
          },
          nome: {
            id: 'cfg-eti--nome',
            status: '',
            value: '',
            apiEnv: 'nome',
            nome: 'Nome do modelo:',
            explica: { mensagem: 'Preencha um nome personalizado para este modelo' },
            onChange: this.cfgEtiquetaOnChange
          },
          celula_mm_largura: {
            id: 'cfg-eti--celula_mm_largura',
            status: '',
            value: '',
            apiEnv: 'celula_mm_largura',
            nome: 'Largura etiqueta (mm):',
            explica: { mensagem: 'Largura em milímetros da célula da etiqueta' },
            onChange: this.cfgEtiquetaOnChange
          },
          celula_mm_altura: {
            id: 'cfg-eti--celula_mm_altura',
            status: '',
            value: '',
            apiEnv: 'celula_mm_altura',
            nome: 'Altura etiqueta (mm):',
            explica: { mensagem: 'Altura em milímetros da célula da etiqueta' },
            onChange: this.cfgEtiquetaOnChange
          },
          celula_linha_qtde: {
            id: 'cfg-eti--celula_linha_qtde',
            status: '',
            value: '',
            apiEnv: 'celula_linha_qtde',
            nome: 'Quantidade de colunas:',
            explica: { mensagem: 'Quantidade de células que estarão dispostas em uma linha' },
            onChange: this.cfgEtiquetaOnChange
          },
          pagina_linha_qtde: {
            id: 'cfg-eti--pagina_linha_qtde',
            status: '',
            value: '',
            nome: 'Qtde de linhas por página:',
            keyValue: 'id',
            keyMostra: [ 'id' ],
            options: [ { id: '1' }, { id: '2' }, { id: '3' }, { id: '4' }, { id: '5' }, { id: '6' }, { id: '7' }, { id: '8' }, { id: '9' }, { id: '10' }, { id: '11' }, { id: '12' }, { id: '13' }, { id: '14' }, { id: '15' }, { id: '16' }, { id: '17' }, { id: '18' }, { id: '19' }, { id: '20' }, { id: '21' }, { id: '22' }, { id: '23' }, { id: '24' }, { id: '25' }, { id: '26' }, { id: '27' }, { id: '28' }, { id: '29' }, { id: '30' }, { id: '31' }, { id: '32' }, { id: '33' }, { id: '34' }, { id: '35' }, { id: '36' }, { id: '37' }, { id: '38' }, { id: '39' }, { id: '40' }, { id: '41' }, { id: '42' }, { id: '43' }, { id: '44' }, { id: '45' }, { id: '46' }, { id: '47' }, { id: '48' }, { id: '49' }, { id: '50' }, { id: '51' }, { id: '52' }, { id: '53' }, { id: '54' }, { id: '55' }, { id: '56' }, { id: '57' }, { id: '58' }, { id: '59' }, { id: '60' }, { id: '61' }, { id: '62' }, { id: '63' }, { id: '64' }, { id: '65' }, { id: '66' }, { id: '67' }, { id: '68' }, { id: '69' }, { id: '70' }, { id: '71' }, { id: '72' }, { id: '73' }, { id: '74' }, { id: '75' }, { id: '76' }, { id: '77' }, { id: '78' }, { id: '79' }, { id: '80' }, { id: '81' }, { id: '82' }, { id: '83' }, { id: '84' }, { id: '85' }, { id: '86' }, { id: '87' }, { id: '88' }, { id: '89' }, { id: '90' }, { id: '91' }, { id: '92' }, { id: '93' }, { id: '94' }, { id: '95' }, { id: '96' }, { id: '97' }, { id: '98' }, { id: '99' }, { id: '100' } ],
            optionInicialNome: 'Tudo',
            onChange: this.cfgEtiquetaOnChange
          },
          margem_esquerda: {
            id: 'cfg-eti--margem_esquerda',
            status: '',
            value: '',
            apiEnv: 'margem_esquerda',
            nome: 'Margem esquerda (mm):',
            explica: { mensagem: 'Tamanho da margem do papel em milímetros' },
            onChange: this.cfgEtiquetaOnChange
          },
          margem_topo: {
            id: 'cfg-eti--margem_topo',
            status: '',
            value: '',
            apiEnv: 'margem_topo',
            nome: 'Margem topo (mm):',
            explica: { mensagem: 'Tamanho da margem do papel em milímetros' },
            onChange: this.cfgEtiquetaOnChange
          },
          margem_direita: {
            id: 'cfg-eti--margem_direita',
            status: '',
            value: '',
            apiEnv: 'margem_direita',
            nome: 'Margem direita (mm):',
            explica: { mensagem: 'Tamanho da margem do papel em milímetros' },
            onChange: this.cfgEtiquetaOnChange
          },
          margem_rodape: {
            id: 'cfg-eti--margem_rodape',
            status: '',
            value: '',
            apiEnv: 'margem_rodape',
            nome: 'Margem rodapé (mm):',
            explica: { mensagem: 'Tamanho da margem do papel em milímetros' },
            onChange: this.cfgEtiquetaOnChange
          },
          celula_conteudo: {
            id: 'cfg-eti--celula_conteudo',
            status: '',
            tabIndex: 17040003,
            nome: 'Conteúdo da etiqueta:',
            config: {
              allowedContent : true, //desativa alteração
              // fillEmptyBlocks : false, //para de inserir &nbsp; em blocos vazios Ex <td></td>
              extraPlugins: 'codigoRotinaFacil',
              removeButtons: 'Save,NewPage,Preview,Print,Templates,About,ShowBlocks,Cut,Copy,Paste,PasteText,PasteFromWord,Undo,Redo,Find,Replace,SelectAll,Scayt,Form,Checkbox,Radio,TextField,Textarea,Select,Button,ImageButton,HiddenField,CopyFormatting,Subscript,Superscript,Blockquote,CreateDiv,Outdent,Indent,BidiLtr,BidiRtl,Language,Anchor,Image,Flash,HorizontalRule,Smiley,SpecialChar,PageBreak,Iframe,Styles,Format',
              toolbarGroups: [
                { name: 'tools', groups: [ 'tools' ] },
                { name: 'document', groups: [ 'mode', 'document', 'doctools' ] },
                { name: 'clipboard', groups: [ 'clipboard', 'undo' ] },
                { name: 'editing', groups: [ 'find', 'selection', 'spellchecker', 'editing' ] },
                { name: 'forms', groups: [ 'forms' ] },
                { name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ] },
                { name: 'paragraph', groups: [ 'list', 'indent', 'blocks', 'align', 'bidi', 'paragraph' ] },
                { name: 'links', groups: [ 'links' ] },
                { name: 'insert', groups: [ 'insert' ] },
                { name: 'styles', groups: [ 'styles' ] },
                { name: 'colors', groups: [ 'colors' ] },
                { name: 'others', groups: [ 'others' ] },
                { name: 'about', groups: [ 'about' ] }
              ],
              height: '200'
            },
            explica: null,
            value: '',
            apiEnv: 'celula_conteudo',
            onChange: this.cfgEtiquetaOnChange
          },
          padrao: {
            id: 'cfg-eti--padrao',
            status: '',
            nome: 'Modelo padrão?',
            value: false,
            apiEnv: 'padrao',
            explica: { mensagem: 'Marque está opção para tornar esse modelo padrão.' },
            onChange: this.cfgEtiquetaOnChange
          },
          atualizarPDR: {
            id: 'cfg-eti--atualizarPDR',
            status: '',
            nome: 'Atualizar padrão modelo?',
            value: false,
            disabled: false,
            apiEnv: 'padrao',
            explica: { mensagem: 'Marque está opção para atualizar o conteudo padrão deste modelo.' },
            onChange: this.cfgEtiquetaOnChange
          },
          qtdeEx: {
            id: 'eti-ite-add--qtdeEx',
            status: '',
            nome: 'Qtde exemplo',
            apiEnv: 'qtdeEx',
            value: '12',
            mostrar: true,
            onChange: this.cfgEtiquetaOnChange,
            onBlur: () => {
              // SETA A QUANTIDADE A GERAR
              this.etiquetas.qtde = this.campos.qtdeEx.value

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()
            }
          }
        }
      }
    },
    mounted: function () {
      this.cfgEtiquetaIniciar()
    },
    methods: {
      cfgEtiquetaIniciar: function () {
        // SETA O STATUS DA TELA
        this.cfgEtiquetaSetarStatusGeral('carregando')

        // LIMPA O CAMPO SELETOR
        this.campos.seletor.value = ''
        this.campos.seletor.options = []

        // LIMPA O CAMPO COPIAR
        this.campos.copiar.value = ''
        this.campos.copiar.options = []

        // SETA O HTML DO MODELO 1
        // this.campos.papelL.value = '512'
        // this.campos.papelP.value = '20 15'
        // this.campos.modelo.value = '<table border="0" cellpadding="1" cellspacing="1" style="width:160px;"><tbody><tr><td style="text-align: center;">#item.nome#</td></tr><tr><td style="text-align: center;">#item.valor_ven#</td></tr><tr><td style="text-align: center;">#item.imagem.cod.barra#</td></tr><tr><td style="text-align: center;">#item.digitos.cod.barra#</td></tr></tbody></table>'

        // this.campos.nome.value = 'Modelo 02'
        // this.campos.papelL.value = '545'
        // this.campos.papelP.value = '20 15'
        // this.campos.modelo.value = '<table border="0" cellpadding="1" cellspacing="1" style="width:160px; margin: 10px 5px"> <tbody> <tr> <td rowspan="4" style="text-align: center;"> <div style="transform: rotate(-90deg) scale(2);">#minha.logo#</div> </td> <td style="text-align: center;">#item.nome#</td> </tr> <tr> <td style="text-align: center;">#item.valor_ven#</td> </tr> <tr> <td style="text-align: center;">#item.imagem.cod.barra#</td> </tr> <tr> <td style="text-align: center;">#item.digitos.cod.barra#</td> </tr> </tbody> </table>'

        // this.campos.nome.value = 'Modelo 03'
        // this.campos.papelL.value = '545'
        // this.campos.papelP.value = '20 15'
        // this.campos.modelo.value = '<table border="0" cellpadding="1" cellspacing="1" style="width:160px; margin: 10px 5px"> <tbody> <tr> <td style="text-align: center;">#minha.logo#</td> </tr> <tr> <td style="text-align: center;">#item.id_cat_nome#</td> </tr> <tr> <td style="text-align: right;">#item.valor_for_cripto#</td> </tr> <tr> <td style="text-align: center;">#item.digitos.cod.barra#</td> </tr> <tr> <td style="text-align: center;">#item.imagem.cod.barra#</td> </tr> <tr> <td style="text-align: center;">#item.digitos.cod.barra#</td> </tr> <tr> <td style="text-align: center;">#item.valor_ven#</td> </tr> </tbody></table>'

        // CARREGA OS CODIGOS RF
        this.cfgEtiquetaBuscarCodigoRotinaFacil(() => {
          this.cfgEtiquetaBuscarModelos(() => {
            // PEGA O OPTION PADRAO
            var padrao = this.campos.seletor.options.filter(item => [ true, 'true', '1', 1, 's', 'S' ].indexOf(item.padrao) !== -1)

            // VERIFICA SE TEM QUE SETAR MODELO PADRÃO
            if (padrao.length >= 1) {
              this.cfgEtiquetaOnChange(padrao[0], this.campos.seletor.id)
            }

            // SETA O STATUS DA TELA
            this.cfgEtiquetaSetarStatusGeral('')
          }, this.campos.seletor.id)
        })
      },
      cfgEtiquetaSetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      cfgEtiquetaSetarStatusBotao: function (status) {
        // SETA O STATUS DA TELA
        this.statusButton = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      cfgEtiquetaSalvar: function () {
        // SETA O STATUS DO BOTÃO
        this.cfgEtiquetaSetarStatusBotao('carregando')

        // REMOVE O FOCUS DE QUALQUER CAMPO
        if (document.activeElement !== document.body) {
          document.activeElement.blur()
        }

        // INICIA A VARIAVEL
        var method = 'POST'

        // INICIA O VETOR
        var formData = { model: this.cpntTipo }

        // SETA O NOME DO MODELO
        formData.nome = this.campos.nome.value

        // SETA O CONTEUDO
        formData.celula_conteudo = this.campos.celula_conteudo.value

        // SETA A LARGURA
        formData.celula_mm_largura = this.campos.celula_mm_largura.value

        // SETA A ALTURA
        formData.celula_mm_altura = this.campos.celula_mm_altura.value

        // SETA O VALOR DO CAMPO RECEBIDO
        formData.margem_esquerda = this.campos.margem_esquerda.value

        // SETA O VALOR DO CAMPO RECEBIDO
        formData.margem_topo = this.campos.margem_topo.value

        // SETA O VALOR DO CAMPO RECEBIDO
        formData.margem_direita = this.campos.margem_direita.value

        // SETA O VALOR DO CAMPO RECEBIDO
        formData.margem_rodape = this.campos.margem_rodape.value

        // SETA SE O MODELO É PADRÃO OU NÃO
        formData.padrao = [ true, 'true', '1', 1, 's', 'S' ].indexOf(this.campos.padrao.value) !== -1 ? 's' : 'n'

        // REMOVE A VARIAVEL
        if (formData.padrao === 'n') {
          delete formData.padrao
        }
        
        // VERIFICA SE DEVE INFORMAR OU NÃO ESSE CAMPO
        if (this.$store.state.token.usuario === 'SuporteRF') {
          // SETA O VALOR DO CAMPO
          formData.f_celula_conteudo_padrao_atualizar = [ true, 'true', '1', 1, 's', 'S' ].indexOf(this.campos.atualizarPDR.value) !== -1 ? 's' : 'n'

          // REMOVE A VARIAVEL
          if (formData.f_celula_conteudo_padrao_atualizar === 'n') {
            delete formData.f_celula_conteudo_padrao_atualizar
          }
        }

        // SETA A QTDE
        formData.celula_linha_qtde = this.campos.celula_linha_qtde.value

        // SETA SE O MODELO É PADRÃO OU NÃO
        formData.pagina_linha_qtde = typeof this.campos.pagina_linha_qtde.value === 'string' ? this.campos.pagina_linha_qtde.value : this.campos.pagina_linha_qtde.value.id
        formData.pagina_linha_qtde = [ '', null, undefined ].indexOf(formData.pagina_linha_qtde) !== -1 ? null : Number(formData.pagina_linha_qtde)

        // VERIFICA SE ESTÁ EDITANDO OU INSERINDO
        if (this.cpntComputedSeletor !== '' && this.cpntComputedSeletor !== '__NOVO__') {
          // SETA O ID QUE ESTÁ EDITANDO
          formData.id = this.cpntComputedSeletor
          
          // SETA O METHODS QUE DEVE CHAMAR
          method = 'PUT'
        }

        // CONVERTE EM LOT
        formData = { lot: [ formData ] }
        
        // FAZ A FINALIZAÇÃO
        var finalizacao = () => {
          // SETA A ATUALIZAÇÃO NO UPDATE
          this.updateVis = new Date().getTime()

          // SETA O STATUS DO BOTÃO
          this.cfgEtiquetaSetarStatusBotao('')
        }

        // COMUNICA COM A API
        this.$store.state.comunicaAPI('/etiqueta/modelo', method, formData, (retorno) => {
          // PEGA O RETORNO RECEBIDO
          retorno = retorno.lot[0]
          
          // VERIFICA O RETORNO RECEBIDO
          if (retorno.code === '200') {
            // APRESENTA A MENSAGEM DE SUCESSO
            this.$store.state.TRATAR_RET_LOT_API(retorno)

            // VERIFICA SE TA ATUALIZANDO OU INSERINDO
            this.cfgEtiquetaBuscarModelos(() => {
              // PEGA O ID QUE ESTA SENDO EDITADO OU INSERIDO
              var refId = retorno.id !== undefined ? retorno.id : retorno.ref.id

              // PEGA O OPTION RECEBIDO
              var option = this.campos.seletor.options.filter(item => item.id === refId)

              // FAZ A ALTERAÇÃO DOS VALORES NO CAMPO
              this.cfgEtiquetaOnChange(option[0], this.campos.seletor.id)

              // LIBERA OS BOTOES
              finalizacao()
            }, this.campos.seletor.id)
          } else {
            this.cfgEtiquetaTratarValidacao(retorno.message, retorno.code, finalizacao)
          }
        }, this.cfgEtiquetaSetarStatusBotao, (apiValid, apiStatus) => { this.cfgEtiquetaTratarValidacao(apiValid, apiStatus, finalizacao) })
      },
      cfgEtiquetaTratarValidacao: function (apiValid, apiStatus = 400, callback = null) {
        // IMPORTA A FUNÇÃO QUE SERÁ UTILIZADA
        const FUN_TRATAR_VALIDACAO_API = require('@/assets/js/Funcoes-Gerais.js').FUN_TRATAR_VALIDACAO_API

        // FAZ A VERIFICAÇÃO E MONTAGEM DO FORMULARIO
        FUN_TRATAR_VALIDACAO_API(apiValid, apiStatus, this.campos, this).then(() => {
          // SETA O STATUS DA TELA
          this.cfgEtiquetaSetarStatusBotao('')
          
          // EXECUTA O CALLBACK RECEBIDO
          if (callback !== null && typeof callback === 'function') {
            callback()
          }
        })
      },
      cfgEtiquetaBuscarModelos: function (callback, id, total = null, registros = []) {
        // PEGA O NOME DO CAMPO QUE ESTÁ SENDO ALTERADO
        var indexF = id.split('--')[1]

        // VERIFICA SE TEM QUE BUSCAR
        if (total === null || total < registros.length) {
          // SETA OS VALORES RECEBIDOS
          this.campos[indexF].status = 'carregando'

          // MONTA O QUERY GET
          var queryGet = { type: 'list', limit: { row: registros.length, qty: 1000 } }

          // SETA O NOME DOS CAMPOS
          queryGet.field = { id: null, nome: null, celula_conteudo: null, celula_conteudo_padrao: null, celula_mm_largura: null, celula_mm_altura: null, padrao: null, celula_linha_qtde: null, pagina_linha_qtde: null, margem_esquerda: null, margem_topo: null, margem_direita: null, margem_rodape: null }

          // ORDENA 
          queryGet.order = { nome: 'asc' }

          // SETA O WHERE
          queryGet.where = { aAnd: [ { f: 'status', o: '=', v: '1' }, { f: 'model', o: '=', v: this.cpntTipo } ] }

          // PEGA REGISTRO DIFERENTE DO PROPRIO REGISTRO
          if (indexF !== 'seletor' && [ '', '__NOVO__' ].indexOf(this.cpntComputedSeletor) === -1) {
            queryGet.where.aAnd.push({ f: 'id', o: '<>', v: this.cpntComputedSeletor })
          }
  
          // FAZ A BUSCA DOS DADOS
          this.$store.state.comunicaAPI('/etiqueta/modelo/get', 'POST', queryGet, (apiSuccess) => {
            // JUNTA OS VALORES RECEBIDOS
            registros = registros.concat(apiSuccess.data)

            // CHAMA A FUNÇÃO PARA BUSCAR OS PROXIMOS REGISTROS
            this.cfgEtiquetaBuscarModelos(callback, id, Number(apiSuccess.countAll), registros)
          }, (apiError) => {
            // SETA OS VALORES RECEBIDOS
            this.campos[indexF].status = apiError

            // SETA OS VALORES RECEBIDOS
            this.campos[indexF].status = ''

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          })
        } else if (total === 0) {
          // SETA OS VALORES RECEBIDOS
          this.campos[indexF].onBuscarOptions = null

          // SETA OS VALORES RECEBIDOS
          this.campos[indexF].status = ''

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        } else {
          // SETA A OPÇÃO PARA INSERIR NOVO
          if (indexF === 'seletor') {
            registros.unshift({
              id: '__NOVO__', 
              nome: 'Inserir Novo Modelo',
              celula_conteudo: '',
              celula_conteudo_padrao: '',
              celula_mm_largura: '',
              celula_mm_altura: '',
              celula_linha_qtde: '',
              pagina_linha_qtde: '',
              margem_esquerda: '',
              margem_topo: '',
              margem_direita: '',
              margem_rodape: '',
              padrao: 'n'
            })

            // BUSCA O VALOR PADRÃO
            var index = registros.findIndex(item => item.padrao === 's')
  
            // VERIFICA SE TEM OPTION PARA DEIXAR NEGRITO
            this.campos.seletor.optionBold = index !== -1 ? registros[index].id : ''
          }          

          // SETA OS VALORES RECEBIDOS
          this.campos[indexF].options = registros

          // SETA OS VALORES RECEBIDOS
          this.campos[indexF].status = ''

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        }
      },      
      cfgEtiquetaOnChange: function (value, id) {
        // PEGA O NOME DO CAMPO QUE ESTÁ SENDO ALTERADO
        var indexF = id.split('--')

        // SETA O VALOR RECEBIDO
        this.campos[indexF[1]].value = value

        // LIMPA O CAMPO DE MENSAGEM DE ERRO
        this.campos[indexF[1]].mensagem = ''

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // VERIFICA A AÇÃO DO CAMPO
        switch (indexF[1]) {
          case 'seletor':
            if ([ '', null, undefined ].indexOf(value.id) === -1) {
              // LIMPA O VALOR DO CAMPO
              if (value.id === '__NOVO__') {
                value.nome = ''
              }

              // SETA O MODELO
              this.etiquetas.modelo = value.id === '__NOVO__' ? '' : value.id
  
              // SETA OS VALORES RECEBIDOS
              this.$set(this.campos.nome, 'value', value.nome)
              this.$set(this.campos.nome, 'mensagem', '')
              this.$set(this.campos.celula_mm_largura, 'value', value.celula_mm_largura)
              this.$set(this.campos.celula_mm_largura, 'mensagem', '')
              this.$set(this.campos.celula_mm_altura, 'value', value.celula_mm_altura)
              this.$set(this.campos.celula_mm_altura, 'mensagem', '')
              this.$set(this.campos.padrao, 'value', [ true, 'true', '1', 1, 's', 'S' ].indexOf(value.padrao) !== -1)
              this.$set(this.campos.padrao, 'mensagem', '')
              this.$set(this.campos.celula_linha_qtde, 'value', value.celula_linha_qtde)
              this.$set(this.campos.celula_linha_qtde, 'mensagem', '')
              this.$set(this.campos.pagina_linha_qtde, 'value', value.pagina_linha_qtde)
              this.$set(this.campos.pagina_linha_qtde, 'mensagem', '')
              this.$set(this.campos.margem_esquerda, 'value', value.margem_esquerda)
              this.$set(this.campos.margem_esquerda, 'mensagem', '')
              this.$set(this.campos.margem_topo, 'value', value.margem_topo)
              this.$set(this.campos.margem_topo, 'mensagem', '')
              this.$set(this.campos.margem_direita, 'value', value.margem_direita)
              this.$set(this.campos.margem_direita, 'mensagem', '')
              this.$set(this.campos.margem_rodape, 'value', value.margem_rodape)
              this.$set(this.campos.margem_rodape, 'mensagem', '')
              this.$set(this.campos.celula_conteudo, 'value', value.celula_conteudo)
              this.$set(this.campos.celula_conteudo, 'mensagem', '')

              // VERIFICA SE DEVE DESABILITAR O CAMPO
              if (this.campos.padrao.value === true) {
                setTimeout(() => {
                  // SETA O STATUS DO CAMPO
                  this.campos.padrao.disabled = true

                  // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                  this.time = new Date().getTime()
                }, 600)
              } else {
                // SETA O STATUS DO CAMPO
                this.campos.padrao.disabled = false

                // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                this.time = new Date().getTime()
              }

              // LIMPA O CAMPO COPIAR
              this.campos.copiar.value = ''
              this.campos.copiar.options = []
              
              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()
            }
            break

          case 'copiar':
            if ([ '', null, undefined ].indexOf(value.id) === -1) {
              this.$set(this.campos.celula_mm_largura, 'value', value.celula_mm_largura)
              this.$set(this.campos.celula_mm_largura, 'mensagem', '')
              this.$set(this.campos.celula_mm_altura, 'value', value.celula_mm_altura)
              this.$set(this.campos.celula_mm_altura, 'mensagem', '')
              this.$set(this.campos.padrao, 'value', false)
              this.$set(this.campos.padrao, 'mensagem', '')
              this.$set(this.campos.celula_linha_qtde, 'value', value.celula_linha_qtde)
              this.$set(this.campos.celula_linha_qtde, 'mensagem', '')
              this.$set(this.campos.pagina_linha_qtde, 'value', value.pagina_linha_qtde)
              this.$set(this.campos.pagina_linha_qtde, 'mensagem', '')
              this.$set(this.campos.margem_esquerda, 'value', value.margem_esquerda)
              this.$set(this.campos.margem_esquerda, 'mensagem', '')
              this.$set(this.campos.margem_topo, 'value', value.margem_topo)
              this.$set(this.campos.margem_topo, 'mensagem', '')
              this.$set(this.campos.margem_direita, 'value', value.margem_direita)
              this.$set(this.campos.margem_direita, 'mensagem', '')
              this.$set(this.campos.margem_rodape, 'value', value.margem_rodape)
              this.$set(this.campos.margem_rodape, 'mensagem', '')
              this.$set(this.campos.celula_conteudo, 'value', value.celula_conteudo)
              this.$set(this.campos.celula_conteudo, 'mensagem', '')

              // LIMPA O VALOR SELECIONADO
              this.$set(this.campos.copiar, 'value', '')
              this.$set(this.campos.copiar, 'mensagem', '')
              
              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()
            }
            break
        }
      },

      cfgEtiquetaBuscarCodigoRotinaFacil: function (callback = null) {
        this.$store.state.comunicaAPI('/subase/codigo-rf/get/etiqueta/', 'GET', this.cpntTipo, (retorno) => {
          // INICIA O VETOR
          var vetor = {}

          // RODA DOS DADOS RECEBIDOS
          for (var index in retorno.data) {
            vetor[retorno.data[index].codigo] = retorno.data[index].descricao
          }

          // SETA OS CODIGOS ROTINA FÁCIL
          window.codigoRotinaFacil = vetor
          
          // EXECUTA O CALLBACK RECEBIDO
          if (callback !== null) {
            callback()
          }
        }, this.cfgEtiquetaSetarStatusGeral)
      }
    },
    computed: {
      cpntComputedSeletor: function () {
        // INICIA A VARIAVEL
        var valor = ''

        // PEGA O VALOR SELECIONADO
        if (typeof this.campos.seletor.value === 'string') {
          valor = this.campos.seletor.value
        } else if (this.campos.seletor.value.id !== undefined) {
          valor = this.campos.seletor.value.id
        } else if (this.campos.seletor.value._id !== undefined) {
          valor = this.campos.seletor.value._id
        }

        // RETORNA O VALOR ENCONTRADO
        return valor
      }
    },
    watch: {
      'cpntTipo': function () {
        // LIMPA VARIAVEL DE RESQUEST API VALIDAS
        this.$store.commit('SET_CANCEL_REQUEST_API')

        // SETA O STATUS DA TELA
        this.cfgEtiquetaSetarStatusGeral('carregando')

        // REINICIA O CARREGAMENTO DO CAMPO
        this.cfgEtiquetaIniciar()
      }
    }
  }
</script>
